import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { getNfts, selectNft } from 'features/auth/nftSlice';
import NftData from 'interfaces/NftData.interface';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './style.css';

function NftDetailsFirstSection() {
  const { id } = useParams();
  const nftState = useAppSelector(selectNft);
  const [nft, setNft] = useState<NftData>();
  const dispatch = useAppDispatch();
  const authState = useAppSelector(selectAuth);
  useEffect(() => {
    if (!nftState.nfts) dispatch(getNfts());
    //eslint-disable-next-line
  }, [authState.id]);

  useEffect(() => {
    if (nftState.nfts && id) {
      setNft(
        nftState.nfts.find(data => {
          if (data.id) return +data.id === +id;
          else return false;
        })
      );
    }
  }, [id, nftState.nfts]);
  if (nft?.image)
    return (
      <div className="main__header">
        <video
          poster={nft?.image}
          src={nft?.image}
          className="main__logo"
          muted
          autoPlay
        ></video>

        <div className="bg__overlay"></div>
      </div>
    );
  return null;
}

export default NftDetailsFirstSection;
